export default __webpack_public_path__ + "cefe9effeb49596ef84fee4c10a7861a.png";